import { render, staticRenderFns } from "./copyBomDetail.vue?vue&type=template&id=5f1b3425&scoped=true&"
import script from "./copyBomDetail.vue?vue&type=script&lang=js&"
export * from "./copyBomDetail.vue?vue&type=script&lang=js&"
import style0 from "./copyBomDetail.vue?vue&type=style&index=0&id=5f1b3425&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b3425",
  null
  
)

export default component.exports